import React from "react";
import { ToastStack as StyledToastStack, Toast, ToastHeader, ToastTitle, ToastDismiss, ToastMessage } from "../styles";
import Icon from "./Icon";

const ToastStack = ({ items, onDismiss }) => {
  return (
    <StyledToastStack>
      {items.map((t) => (
        <Toast key={t.id}>
          <ToastHeader>
            <ToastTitle>{t.title}</ToastTitle>
            <ToastDismiss onClick={() => onDismiss(t.id)} aria-label="Dismiss">
              <Icon name="x" />
            </ToastDismiss>
          </ToastHeader>
          <ToastMessage>{t.msg}</ToastMessage>
        </Toast>
      ))}
    </StyledToastStack>
  );
};

export default ToastStack;
